module.exports = __webpack_public_path__ + "img/order_detail.965c40b8.png";